import Modal from "@components/atoms/Modal";
import React from "react";
import { ReportAnIssueModalProps } from "./types";
import { useTranslation } from "react-i18next";
import ReportAnIssueScreen from "./ReportAnIssueScreen";

const ReportAnIssueModal = ({
  isOpen,
  onClose,
  itemDetail,
}: ReportAnIssueModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      headerTitle={t("reportAnIssue.title.text")}
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={0}
      paddingRight={0}
      paddingTop={0}
      paddingBottom={0}
    >
      <ReportAnIssueScreen itemDetail={itemDetail} onClose={onClose} />
    </Modal>
  );
};

export default ReportAnIssueModal;
